import React, { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

/**
 * PolicyTranslationUserSelect
 * Shared between PolicyTranslation and UseCases
 */
const PolicyTranslationUserSelect = ({
  users,
  selectedUser,
  setSelectedUser,
  sx,
}) => {
  return (
    <FormControl fullWidth variant="outlined" sx={sx}>
      <Select id="select" value={selectedUser} onChange={setSelectedUser}>
        {users.map((user) => (
          <MenuItem key={user.userKey} value={user.userEmailAddress}>
            {`${user.userFirstName} ${user.userLastName}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PolicyTranslationUserSelect;
